// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/attribute/v1/attribute.proto" (package "c1.api.attribute.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * CreateAttributeValueResponse is the response for creating an attribute value.
 *
 * @generated from protobuf message c1.api.attribute.v1.CreateAttributeValueResponse
 */
export interface CreateAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateAttributeValueRequest
 */
export interface CreateAttributeValueRequest {
    /**
     * @generated from protobuf field: string attribute_type_id = 1
     */
    attributeTypeId: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse
 */
export interface CreateComplianceFrameworkAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest
 */
export interface CreateComplianceFrameworkAttributeValueRequest {
    /**
     * @generated from protobuf field: string value = 1
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest
 */
export interface DeleteComplianceFrameworkAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse
 */
export interface DeleteComplianceFrameworkAttributeValueResponse {
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest
 */
export interface GetComplianceFrameworkAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse
 */
export interface GetComplianceFrameworkAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse
 */
export interface CreateRiskLevelAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest
 */
export interface CreateRiskLevelAttributeValueRequest {
    /**
     * @generated from protobuf field: string value = 1
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest
 */
export interface DeleteRiskLevelAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse
 */
export interface DeleteRiskLevelAttributeValueResponse {
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueRequest
 */
export interface GetRiskLevelAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueResponse
 */
export interface GetRiskLevelAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValueRequest
 */
export interface GetAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * GetAttributeValueResponse is the response for getting an attribute value by id.
 *
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValueResponse
 */
export interface GetAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListComplianceFrameworksRequest
 */
export interface ListComplianceFrameworksRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListComplianceFrameworksResponse
 */
export interface ListComplianceFrameworksResponse {
    /**
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1
     */
    list: AttributeValue[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListRiskLevelsRequest
 */
export interface ListRiskLevelsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListRiskLevelsResponse
 */
export interface ListRiskLevelsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1
     */
    list: AttributeValue[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * AttributeType defines the type of an attribute.
 *
 * @generated from protobuf message c1.api.attribute.v1.AttributeType
 */
export interface AttributeType {
    /**
     * The ID of the AttributeType.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The name of the AttributeType.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * AttributeValue is the value of an attribute of a defined type.
 *
 * @generated from protobuf message c1.api.attribute.v1.AttributeValue
 */
export interface AttributeValue {
    /**
     * The ID of the AttributeValue.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The ID of the AttributeType that this AttributeValue belongs to.
     *
     * @generated from protobuf field: string attribute_type_id = 2
     */
    attributeTypeId: string;
    /**
     * The value of the AttributeValue. This is the string that will be displayed to the user.
     *
     * @generated from protobuf field: string value = 3
     */
    value: string;
    /**
     * The datetime, in RFC3339 format, of when the AttributeValue was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AttributeValue was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AttributeValue was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValuesRequest
 */
export interface GetAttributeValuesRequest {
    /**
     * @generated from protobuf field: repeated string attribute_ids = 1
     */
    attributeIds: string[];
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValuesResponse
 */
export interface GetAttributeValuesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue items = 1
     */
    items: AttributeValue[];
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeValuesRequest
 */
export interface ListAttributeValuesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string attribute_type_id = 3
     */
    attributeTypeId: string;
}
/**
 * ListAttributeValuesResponse is the response for listing attribute values for a given AttributeType.
 *
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeValuesResponse
 */
export interface ListAttributeValuesResponse {
    /**
     * The list of AttributeValues.
     *
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1
     */
    list: AttributeValue[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteAttributeValueRequest
 */
export interface DeleteAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * DeleteAttributeValueResponse is the empty response for deleting an attribute value.
 *
 * @generated from protobuf message c1.api.attribute.v1.DeleteAttributeValueResponse
 */
export interface DeleteAttributeValueResponse {
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeTypesRequest
 */
export interface ListAttributeTypesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * ListAttributeTypesResponse is the response for listing attribute types.
 *
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeTypesResponse
 */
export interface ListAttributeTypesResponse {
    /**
     * The list of AttributeTypes.
     *
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeType list = 1
     */
    list: AttributeType[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Search Attributes by a few properties.
 *
 * @generated from protobuf message c1.api.attribute.v1.SearchAttributeValuesRequest
 */
export interface SearchAttributeValuesRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the attributes with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * The attribute type ids for what type of attributes to search for.
     *
     * @generated from protobuf field: repeated string attribute_type_ids = 4
     */
    attributeTypeIds: string[];
    /**
     * Exclude attributes with these ids from the search results.
     *
     * @generated from protobuf field: repeated string exclude_ids = 5
     */
    excludeIds: string[];
    /**
     * Include attributes with these ids in the search results.
     *
     * @generated from protobuf field: repeated string ids = 6
     */
    ids: string[];
    /**
     * Search for attributes with a case insensitive match on the attribute value which is the attribute name.
     *
     * @generated from protobuf field: string value = 7
     */
    value: string;
}
/**
 * SearchAttributeValuesResponse is the response for searching AttributeValues.
 *
 * @generated from protobuf message c1.api.attribute.v1.SearchAttributeValuesResponse
 */
export interface SearchAttributeValuesResponse {
    /**
     * The list of returned AttributeValues.
     *
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1
     */
    list: AttributeValue[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateAttributeValueResponse$Type extends MessageType<CreateAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.CreateAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<CreateAttributeValueResponse>): CreateAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAttributeValueResponse): CreateAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.attribute.v1.AttributeValue value */ 1:
                    message.value = AttributeValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.attribute.v1.AttributeValue value = 1; */
        if (message.value)
            AttributeValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateAttributeValueResponse
 */
export const CreateAttributeValueResponse = new CreateAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAttributeValueRequest$Type extends MessageType<CreateAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.CreateAttributeValueRequest", [
            { no: 1, name: "attribute_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<CreateAttributeValueRequest>): CreateAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attributeTypeId = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAttributeValueRequest): CreateAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string attribute_type_id */ 1:
                    message.attributeTypeId = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string attribute_type_id = 1; */
        if (message.attributeTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.attributeTypeId);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateAttributeValueRequest
 */
export const CreateAttributeValueRequest = new CreateAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateComplianceFrameworkAttributeValueResponse$Type extends MessageType<CreateComplianceFrameworkAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<CreateComplianceFrameworkAttributeValueResponse>): CreateComplianceFrameworkAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateComplianceFrameworkAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateComplianceFrameworkAttributeValueResponse): CreateComplianceFrameworkAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.attribute.v1.AttributeValue value */ 1:
                    message.value = AttributeValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateComplianceFrameworkAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.attribute.v1.AttributeValue value = 1; */
        if (message.value)
            AttributeValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse
 */
export const CreateComplianceFrameworkAttributeValueResponse = new CreateComplianceFrameworkAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateComplianceFrameworkAttributeValueRequest$Type extends MessageType<CreateComplianceFrameworkAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<CreateComplianceFrameworkAttributeValueRequest>): CreateComplianceFrameworkAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<CreateComplianceFrameworkAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateComplianceFrameworkAttributeValueRequest): CreateComplianceFrameworkAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateComplianceFrameworkAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest
 */
export const CreateComplianceFrameworkAttributeValueRequest = new CreateComplianceFrameworkAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteComplianceFrameworkAttributeValueRequest$Type extends MessageType<DeleteComplianceFrameworkAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteComplianceFrameworkAttributeValueRequest>): DeleteComplianceFrameworkAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteComplianceFrameworkAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteComplianceFrameworkAttributeValueRequest): DeleteComplianceFrameworkAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteComplianceFrameworkAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest
 */
export const DeleteComplianceFrameworkAttributeValueRequest = new DeleteComplianceFrameworkAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteComplianceFrameworkAttributeValueResponse$Type extends MessageType<DeleteComplianceFrameworkAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse", []);
    }
    create(value?: PartialMessage<DeleteComplianceFrameworkAttributeValueResponse>): DeleteComplianceFrameworkAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteComplianceFrameworkAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteComplianceFrameworkAttributeValueResponse): DeleteComplianceFrameworkAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteComplianceFrameworkAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse
 */
export const DeleteComplianceFrameworkAttributeValueResponse = new DeleteComplianceFrameworkAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetComplianceFrameworkAttributeValueRequest$Type extends MessageType<GetComplianceFrameworkAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetComplianceFrameworkAttributeValueRequest>): GetComplianceFrameworkAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetComplianceFrameworkAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetComplianceFrameworkAttributeValueRequest): GetComplianceFrameworkAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetComplianceFrameworkAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest
 */
export const GetComplianceFrameworkAttributeValueRequest = new GetComplianceFrameworkAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetComplianceFrameworkAttributeValueResponse$Type extends MessageType<GetComplianceFrameworkAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<GetComplianceFrameworkAttributeValueResponse>): GetComplianceFrameworkAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetComplianceFrameworkAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetComplianceFrameworkAttributeValueResponse): GetComplianceFrameworkAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.attribute.v1.AttributeValue value */ 1:
                    message.value = AttributeValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetComplianceFrameworkAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.attribute.v1.AttributeValue value = 1; */
        if (message.value)
            AttributeValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse
 */
export const GetComplianceFrameworkAttributeValueResponse = new GetComplianceFrameworkAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRiskLevelAttributeValueResponse$Type extends MessageType<CreateRiskLevelAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<CreateRiskLevelAttributeValueResponse>): CreateRiskLevelAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateRiskLevelAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRiskLevelAttributeValueResponse): CreateRiskLevelAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.attribute.v1.AttributeValue value */ 1:
                    message.value = AttributeValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRiskLevelAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.attribute.v1.AttributeValue value = 1; */
        if (message.value)
            AttributeValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse
 */
export const CreateRiskLevelAttributeValueResponse = new CreateRiskLevelAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRiskLevelAttributeValueRequest$Type extends MessageType<CreateRiskLevelAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<CreateRiskLevelAttributeValueRequest>): CreateRiskLevelAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<CreateRiskLevelAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRiskLevelAttributeValueRequest): CreateRiskLevelAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRiskLevelAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest
 */
export const CreateRiskLevelAttributeValueRequest = new CreateRiskLevelAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRiskLevelAttributeValueRequest$Type extends MessageType<DeleteRiskLevelAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteRiskLevelAttributeValueRequest>): DeleteRiskLevelAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteRiskLevelAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteRiskLevelAttributeValueRequest): DeleteRiskLevelAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteRiskLevelAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest
 */
export const DeleteRiskLevelAttributeValueRequest = new DeleteRiskLevelAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRiskLevelAttributeValueResponse$Type extends MessageType<DeleteRiskLevelAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse", []);
    }
    create(value?: PartialMessage<DeleteRiskLevelAttributeValueResponse>): DeleteRiskLevelAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteRiskLevelAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteRiskLevelAttributeValueResponse): DeleteRiskLevelAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteRiskLevelAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse
 */
export const DeleteRiskLevelAttributeValueResponse = new DeleteRiskLevelAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRiskLevelAttributeValueRequest$Type extends MessageType<GetRiskLevelAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetRiskLevelAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetRiskLevelAttributeValueRequest>): GetRiskLevelAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetRiskLevelAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRiskLevelAttributeValueRequest): GetRiskLevelAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRiskLevelAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueRequest
 */
export const GetRiskLevelAttributeValueRequest = new GetRiskLevelAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRiskLevelAttributeValueResponse$Type extends MessageType<GetRiskLevelAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetRiskLevelAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<GetRiskLevelAttributeValueResponse>): GetRiskLevelAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetRiskLevelAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRiskLevelAttributeValueResponse): GetRiskLevelAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.attribute.v1.AttributeValue value */ 1:
                    message.value = AttributeValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRiskLevelAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.attribute.v1.AttributeValue value = 1; */
        if (message.value)
            AttributeValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueResponse
 */
export const GetRiskLevelAttributeValueResponse = new GetRiskLevelAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValueRequest$Type extends MessageType<GetAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAttributeValueRequest>): GetAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAttributeValueRequest): GetAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValueRequest
 */
export const GetAttributeValueRequest = new GetAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValueResponse$Type extends MessageType<GetAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<GetAttributeValueResponse>): GetAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAttributeValueResponse): GetAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.attribute.v1.AttributeValue value */ 1:
                    message.value = AttributeValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.attribute.v1.AttributeValue value = 1; */
        if (message.value)
            AttributeValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValueResponse
 */
export const GetAttributeValueResponse = new GetAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListComplianceFrameworksRequest$Type extends MessageType<ListComplianceFrameworksRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListComplianceFrameworksRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListComplianceFrameworksRequest>): ListComplianceFrameworksRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListComplianceFrameworksRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListComplianceFrameworksRequest): ListComplianceFrameworksRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListComplianceFrameworksRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListComplianceFrameworksRequest
 */
export const ListComplianceFrameworksRequest = new ListComplianceFrameworksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListComplianceFrameworksResponse$Type extends MessageType<ListComplianceFrameworksResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListComplianceFrameworksResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListComplianceFrameworksResponse>): ListComplianceFrameworksResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListComplianceFrameworksResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListComplianceFrameworksResponse): ListComplianceFrameworksResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.attribute.v1.AttributeValue list */ 1:
                    message.list.push(AttributeValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListComplianceFrameworksResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.attribute.v1.AttributeValue list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AttributeValue.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListComplianceFrameworksResponse
 */
export const ListComplianceFrameworksResponse = new ListComplianceFrameworksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRiskLevelsRequest$Type extends MessageType<ListRiskLevelsRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListRiskLevelsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListRiskLevelsRequest>): ListRiskLevelsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListRiskLevelsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListRiskLevelsRequest): ListRiskLevelsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListRiskLevelsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListRiskLevelsRequest
 */
export const ListRiskLevelsRequest = new ListRiskLevelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRiskLevelsResponse$Type extends MessageType<ListRiskLevelsResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListRiskLevelsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListRiskLevelsResponse>): ListRiskLevelsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListRiskLevelsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListRiskLevelsResponse): ListRiskLevelsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.attribute.v1.AttributeValue list */ 1:
                    message.list.push(AttributeValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListRiskLevelsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.attribute.v1.AttributeValue list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AttributeValue.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListRiskLevelsResponse
 */
export const ListRiskLevelsResponse = new ListRiskLevelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttributeType$Type extends MessageType<AttributeType> {
    constructor() {
        super("c1.api.attribute.v1.AttributeType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<AttributeType>): AttributeType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<AttributeType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttributeType): AttributeType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttributeType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.AttributeType
 */
export const AttributeType = new AttributeType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttributeValue$Type extends MessageType<AttributeValue> {
    constructor() {
        super("c1.api.attribute.v1.AttributeValue", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "attribute_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AttributeValue>): AttributeValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.attributeTypeId = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<AttributeValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttributeValue): AttributeValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string attribute_type_id */ 2:
                    message.attributeTypeId = reader.string();
                    break;
                case /* string value */ 3:
                    message.value = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttributeValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string attribute_type_id = 2; */
        if (message.attributeTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.attributeTypeId);
        /* string value = 3; */
        if (message.value !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.value);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.AttributeValue
 */
export const AttributeValue = new AttributeValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValuesRequest$Type extends MessageType<GetAttributeValuesRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValuesRequest", [
            { no: 1, name: "attribute_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GetAttributeValuesRequest>): GetAttributeValuesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attributeIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAttributeValuesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAttributeValuesRequest): GetAttributeValuesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string attribute_ids */ 1:
                    message.attributeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAttributeValuesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string attribute_ids = 1; */
        for (let i = 0; i < message.attributeIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.attributeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValuesRequest
 */
export const GetAttributeValuesRequest = new GetAttributeValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValuesResponse$Type extends MessageType<GetAttributeValuesResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValuesResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue }
        ]);
    }
    create(value?: PartialMessage<GetAttributeValuesResponse>): GetAttributeValuesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<GetAttributeValuesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAttributeValuesResponse): GetAttributeValuesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.attribute.v1.AttributeValue items */ 1:
                    message.items.push(AttributeValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAttributeValuesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.attribute.v1.AttributeValue items = 1; */
        for (let i = 0; i < message.items.length; i++)
            AttributeValue.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValuesResponse
 */
export const GetAttributeValuesResponse = new GetAttributeValuesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeValuesRequest$Type extends MessageType<ListAttributeValuesRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeValuesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "attribute_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAttributeValuesRequest>): ListAttributeValuesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.attributeTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAttributeValuesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAttributeValuesRequest): ListAttributeValuesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string attribute_type_id */ 3:
                    message.attributeTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAttributeValuesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string attribute_type_id = 3; */
        if (message.attributeTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.attributeTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeValuesRequest
 */
export const ListAttributeValuesRequest = new ListAttributeValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeValuesResponse$Type extends MessageType<ListAttributeValuesResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeValuesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAttributeValuesResponse>): ListAttributeValuesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAttributeValuesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAttributeValuesResponse): ListAttributeValuesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.attribute.v1.AttributeValue list */ 1:
                    message.list.push(AttributeValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAttributeValuesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.attribute.v1.AttributeValue list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AttributeValue.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeValuesResponse
 */
export const ListAttributeValuesResponse = new ListAttributeValuesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAttributeValueRequest$Type extends MessageType<DeleteAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.DeleteAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAttributeValueRequest>): DeleteAttributeValueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAttributeValueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAttributeValueRequest): DeleteAttributeValueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAttributeValueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteAttributeValueRequest
 */
export const DeleteAttributeValueRequest = new DeleteAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAttributeValueResponse$Type extends MessageType<DeleteAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.DeleteAttributeValueResponse", []);
    }
    create(value?: PartialMessage<DeleteAttributeValueResponse>): DeleteAttributeValueResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAttributeValueResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAttributeValueResponse): DeleteAttributeValueResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAttributeValueResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteAttributeValueResponse
 */
export const DeleteAttributeValueResponse = new DeleteAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeTypesRequest$Type extends MessageType<ListAttributeTypesRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeTypesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAttributeTypesRequest>): ListAttributeTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAttributeTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAttributeTypesRequest): ListAttributeTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAttributeTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeTypesRequest
 */
export const ListAttributeTypesRequest = new ListAttributeTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeTypesResponse$Type extends MessageType<ListAttributeTypesResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAttributeTypesResponse>): ListAttributeTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAttributeTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAttributeTypesResponse): ListAttributeTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.attribute.v1.AttributeType list */ 1:
                    message.list.push(AttributeType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAttributeTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.attribute.v1.AttributeType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AttributeType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeTypesResponse
 */
export const ListAttributeTypesResponse = new ListAttributeTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAttributeValuesRequest$Type extends MessageType<SearchAttributeValuesRequest> {
    constructor() {
        super("c1.api.attribute.v1.SearchAttributeValuesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "attribute_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "5", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAttributeValuesRequest>): SearchAttributeValuesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.attributeTypeIds = [];
        message.excludeIds = [];
        message.ids = [];
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAttributeValuesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAttributeValuesRequest): SearchAttributeValuesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string attribute_type_ids */ 4:
                    message.attributeTypeIds.push(reader.string());
                    break;
                case /* repeated string exclude_ids */ 5:
                    message.excludeIds.push(reader.string());
                    break;
                case /* repeated string ids */ 6:
                    message.ids.push(reader.string());
                    break;
                case /* string value */ 7:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAttributeValuesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string attribute_type_ids = 4; */
        for (let i = 0; i < message.attributeTypeIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.attributeTypeIds[i]);
        /* repeated string exclude_ids = 5; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* repeated string ids = 6; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.ids[i]);
        /* string value = 7; */
        if (message.value !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.SearchAttributeValuesRequest
 */
export const SearchAttributeValuesRequest = new SearchAttributeValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAttributeValuesResponse$Type extends MessageType<SearchAttributeValuesResponse> {
    constructor() {
        super("c1.api.attribute.v1.SearchAttributeValuesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAttributeValuesResponse>): SearchAttributeValuesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAttributeValuesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAttributeValuesResponse): SearchAttributeValuesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.attribute.v1.AttributeValue list */ 1:
                    message.list.push(AttributeValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAttributeValuesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.attribute.v1.AttributeValue list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AttributeValue.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.SearchAttributeValuesResponse
 */
export const SearchAttributeValuesResponse = new SearchAttributeValuesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.attribute.v1.Attributes
 */
export const Attributes = new ServiceType("c1.api.attribute.v1.Attributes", [
    { name: "CreateComplianceFrameworkAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/attributes/compliance_frameworks", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Compliance Framework" }], group: "Compliance Framework" }] } }, I: CreateComplianceFrameworkAttributeValueRequest, O: CreateComplianceFrameworkAttributeValueResponse },
    { name: "DeleteComplianceFrameworkAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/attributes/compliance_frameworks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Compliance Framework" }], group: "Compliance Framework" }] } }, I: DeleteComplianceFrameworkAttributeValueRequest, O: DeleteComplianceFrameworkAttributeValueResponse },
    { name: "GetComplianceFrameworkAttributeValue", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/compliance_frameworks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Compliance Framework" }], group: "Compliance Framework" }] } }, I: GetComplianceFrameworkAttributeValueRequest, O: GetComplianceFrameworkAttributeValueResponse },
    { name: "CreateRiskLevelAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/attributes/risk_levels", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Risk Level" }], group: "Risk Level" }] } }, I: CreateRiskLevelAttributeValueRequest, O: CreateRiskLevelAttributeValueResponse },
    { name: "DeleteRiskLevelAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/attributes/risk_levels/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Risk Level" }], group: "Risk Level" }] } }, I: DeleteRiskLevelAttributeValueRequest, O: DeleteRiskLevelAttributeValueResponse },
    { name: "GetRiskLevelAttributeValue", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/risk_levels/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Risk Level" }], group: "Risk Level" }] } }, I: GetRiskLevelAttributeValueRequest, O: GetRiskLevelAttributeValueResponse },
    { name: "ListComplianceFrameworks", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/compliance_frameworks", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Compliance Frameworks", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Compliance Framework" }] } }, I: ListComplianceFrameworksRequest, O: ListComplianceFrameworksResponse },
    { name: "ListRiskLevels", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/risk_levels", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Risk Levels", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Risk Level" }] } }, I: ListRiskLevelsRequest, O: ListRiskLevelsResponse },
    { name: "CreateAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/attributes", group: "Attribute" }] } }, I: CreateAttributeValueRequest, O: CreateAttributeValueResponse },
    { name: "GetAttributeValue", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/{id}", group: "Attribute" }] } }, I: GetAttributeValueRequest, O: GetAttributeValueResponse },
    { name: "GetAttributeValues", options: { "authz.method": { role: "VIEWER" } }, I: GetAttributeValuesRequest, O: GetAttributeValuesResponse },
    { name: "ListAttributeValues", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/types/{attribute_type_id}/values", query: { page_size: "page_size", page_token: "page_token" }, group: "Attribute" }] } }, I: ListAttributeValuesRequest, O: ListAttributeValuesResponse },
    { name: "DeleteAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/attribute/{id}", group: "Attribute" }] } }, I: DeleteAttributeValueRequest, O: DeleteAttributeValueResponse },
    { name: "ListAttributeTypes", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/types", query: { page_size: "page_size", page_token: "page_token" }, group: "Attribute" }] } }, I: ListAttributeTypesRequest, O: ListAttributeTypesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.attribute.v1.AttributeSearch
 */
export const AttributeSearch = new ServiceType("c1.api.attribute.v1.AttributeSearch", [
    { name: "SearchAttributeValues", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/attributes", group: "Attribute" }] } }, I: SearchAttributeValuesRequest, O: SearchAttributeValuesResponse }
]);
